import { RefObject, useEffect, useState } from "react"
import { DateTime } from "luxon"
import { debounce } from "lodash-es"
import { Popover, Stack } from "@mui/material"
import FullCalendar from "@fullcalendar/react"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardButton } from "../../../../buttons/StandardButton"
import { useDateTime } from "../../../../../../modules/localization/useDateTime"

export function GoToDatePicker({ calendarRef }: { calendarRef: RefObject<FullCalendar | null> }) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const dateTimeFactory = useDateTime()
    const now = dateTimeFactory.now()

    const [open, setOpen] = useState(false)
    const [openPicker, setOpenPicker] = useState(false)
    const [selectedDate, setSelectedDate] = useState<DateTime | null>(now)

    useEffect(() => {
        const openPickerDebounced = debounce(() => {
            setOpenPicker(true)
        }, 150)

        const handler = (e: Event) => {
            const target = document.querySelector(".fc-goToDate-button") as HTMLElement

            if (target) {
                setAnchorEl(target)
                setOpen(true)
                openPickerDebounced()
            }
        }

        window.addEventListener("open-calendar-date-picker", handler)
        return () => {
            window.removeEventListener("open-calendar-date-picker", handler)
            openPickerDebounced.cancel()
        }
    }, [])

    const handleConfirm = () => {
        if (calendarRef.current && selectedDate) {
            const api = calendarRef.current.getApi()
            api.gotoDate(selectedDate.toISODate())
            api.scrollToTime("08:00:00")
        }
        setOpen(false)
    }

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => setOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
            <Stack gap="1rem" p={2}>
                <LocalizedStrict id="create-order-calendar-go-to-date-label" attrs={{ label: true }}>
                    <DatePicker
                        label="Select date"
                        value={selectedDate}
                        open={openPicker}
                        onOpen={() => setOpenPicker(true)}
                        onClose={() => setOpenPicker(false)}
                        onChange={(date) => {
                            setSelectedDate(date)
                            setOpenPicker(false)
                        }}
                        format="yyyy-MM-dd"
                        minDate={now.startOf("day")}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="create-order-calendar-go-button">
                    <StandardButton onClick={handleConfirm} size="small">
                        Go
                    </StandardButton>
                </LocalizedStrict>
            </Stack>
        </Popover>
    )
}
